import React from "react";
import useTheme from "../../components/useTheme/useTheme.js";
const DashboardPerkCard = (props) => {
  const { theme } = useTheme();
  return (
    <div
      className="perk_card"
      data-aos="fade-up"
      data-aos-delay={props.id * 100}
      key={`perk-${props.id}`}
      style={{
        borderColor: theme === "light" ? "#00000080" : "#ffffff80",
        boxShadow: theme === "light" ? "none" : "",
      }}
    >
      <img
        width={60}
        height={60}
        src={props.icon}
        alt="icon"
        className="perk_icon"
        loading="lazy"
      />
      <p
        className={`desc ${theme === "light" && "text-black"}`}
        dangerouslySetInnerHTML={{ __html: props.desc }}
      />
    </div>
  );
};

export default DashboardPerkCard;
